var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-input-wrapper" }, [
    _c("label", { staticClass: "toggle" }, [
      _c("input", {
        staticClass: "is-sr-only",
        attrs: { type: "checkbox", name: "sustainability-preference" },
        domProps: { checked: _vm.enableSwitcher },
        on: {
          change: function ($event) {
            return _vm.handleChange($event.target.checked)
          },
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "toggle__slider round" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }